export default "__VITE_ASSET__QRDtgz7z__"